export default "__VITE_ASSET__2d55563b__"